/* tslint:disable */
/* eslint-disable */
/**
 * PRTIMES Media User API
 * メディアユーザーマイページ用 API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RequestLocation
 */
export interface RequestLocation {
    /**
     * pref_idに相当
     * @type {string}
     * @memberof RequestLocation
     */
    prefectureId: string;
    /**
     * city_idに相当
     * @type {string}
     * @memberof RequestLocation
     */
    cityId?: string;
}

export function RequestLocationFromJSON(json: any): RequestLocation {
    return RequestLocationFromJSONTyped(json, false);
}

export function RequestLocationFromJSONTyped(json: any, ignoreDiscriminator: boolean): RequestLocation {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'prefectureId': json['prefecture_id'],
        'cityId': !exists(json, 'city_id') ? undefined : json['city_id'],
    };
}

export function RequestLocationToJSON(value?: RequestLocation | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'prefecture_id': value.prefectureId,
        'city_id': value.cityId,
    };
}

